import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import { authRoles } from '../../auth/authRoles'

const AppForm = Loadable(lazy(() => import('./forms/AppForm.jsx')))

const CreateInvoiceRoutes = [
    {
        path: '/create-invoice',
        element: <AppForm />,
        auth: authRoles.admin,
    },
]

export default CreateInvoiceRoutes
